/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.AccessRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type PortalUserRole = 'ADMIN' | 'VIEWER' | 'EDITOR' | unhandledEnumCase;

export type RequestedInstanceAccess = 'GRANTED' | 'DENIED' | unhandledEnumCase;

export type PortalAuthError = {
  reason: PortalAuthErrorReason;
  portalInstanceId?: number;
  denialReason?: string;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type PortalAuthErrorReason =
  | 'AUTHENTICATION_FAILED'
  | 'ACCESS_DENIED'
  | 'UNEXPECTED_ERROR'
  | 'INVALID_PARAMETER_COUNT'
  | 'INVALID_PARAMETER_TYPES'
  | 'MISSING_ACCOUNT_ID'
  | 'MISSING_PORTAL_INSTANCE_ID'
  | 'MISSING_MEMBERSHIP_COOKIE'
  | 'EMPTY_MEMBERSHIP_COOKIE'
  | 'CSRF_ERROR'
  | 'MISSING_CRM_OBJECT_ID'
  | 'MISSING_CRM_OBJECT_ASSOCIATION'
  | 'FORM_NOT_FOUND'
  | 'WRONG_HUBLET'
  | unhandledEnumCase;

export type LoginVerifyContactResponse = {
  contactVid?: number;
  userId?: number;
  membershipUserId?: number;
  masqueradingUserId?: number;
  email?: string;
  firstname?: string;
  lastname?: string;
  jobTitle?: string;
  phone?: string;
  company?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
  preferredLanguage?: string;
  avatarUrl?: string;
  portalUserRole: Default<PortalUserRole>;
  featuresEnabled: Default<string[]>;
  scopes: Default<string[]>;
  requestedInstanceAccess: Default<RequestedInstanceAccess>;
};

export type LoginVerifyRequest = {
  membershipToken?: string;
  utkCookie?: string;
  portalInstanceId?: number;
  accountId?: number;
  objectId?: number;
  membershipCsrfTokenFromClient?: string;
  membershipCsrfTokenFromCookie?: string;
  previewJwt?: string;
  companyId?: number;
  tolerateInstanceAccessDenied?: boolean;
};

export type LoginVerifyRequestType = Requestify<LoginVerifyRequest>;
export type LoginVerifyResponseType = LoginVerifyContactResponse;
export type LoginVerifyErrorType = PortalAuthError & HubspotMetadata;
export const loginVerifyRpc: ChirpAvroRpcDetails<
  LoginVerifyRequestType,
  LoginVerifyResponseType,
  LoginVerifyErrorType,
  false
> = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.AccessRpc',
  rpcName: 'loginVerify',
  auth: 'external',
  fingerprint: 'n9OT-wAY8x4wB6y_HezyjkWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
